<script lang="ts" setup>
    import {computed, defineProps} from "vue";
    import DIcon from "../atoms/DIcon.vue";
    import DContainer from "../atoms/DContainer.vue";
    import DText from "../atoms/DText.vue";

    import DTooltip from "../molecules/DTooltip.vue";
    
    import type {ComponentThemes} from "@songfinch/types";

    const props = withDefaults(defineProps<{
        theme?: ComponentThemes;
        rating: number;
        songsCompleted: number;
        tooltip?: string
    }>(), {
        theme: "light",
        minimal: false,
        songsCompleted: 0,
        tooltip: undefined
    });

    const ratingFillStyle = computed(() => {
        // 80px is toal width of 5 icons
        const shownPixels = 80 * props.rating / 5;

        return {
            width: shownPixels + "px",
        };
    });

    const songsCompletedNormalized = computed(() => {
        if (props.songsCompleted === 0) return undefined;
        if (props.songsCompleted === 1) return `(${props.songsCompleted} song)`;
        return `(${props.songsCompleted > 9999 ? "10k+" : props.songsCompleted} songs)`;
    });
</script>

<template>
    <DContainer class="d-artist-star-rating-container" :theme="theme">
        <DContainer class="d-artist-star-box">
            <DContainer class="d-artist-star-rating-wrapper d-star-rating" :style="ratingFillStyle">
                <DIcon
                    v-for="i in 5"
                    :key="i"
                    name="star"
                    size="small"
                    class="d-star-background"
                />
            </DContainer>
            <DContainer class="d-artist-star-rating-wrapper">
                <DIcon
                    v-for="i in 5"
                    :key="i"
                    name="star_outline"
                    size="small"
                    class="d-star-background"
                />
            </DContainer>
        </DContainer>

        <DText v-if="songsCompletedNormalized" variant="p-4-italic" type="span">
            {{songsCompletedNormalized}}
        </DText>

        <DTooltip v-if="tooltip" :info="tooltip"/>
    </DContainer>
</template>

<style scoped>
    .d-artist-star-rating-container {
        display: flex;
        align-items: center;
        column-gap: 6px;
    }

    .d-artist-star-rating-wrapper {
        display: flex;
        overflow: hidden;
    }

    .d-artist-star-box {
        position: relative;
    }

    .d-star-rating {
        position: absolute;
        left: 0;
        top: 0;
    }
</style>
